const recruiterUserAdapter = (recruiterUserData) => ({
  id: recruiterUserData.id,
  companyId: recruiterUserData.companyId,
  isRecruiter: recruiterUserData.isRecruiter,
  isAdmin: recruiterUserData.isAdmin,
  name: recruiterUserData.name,
  firstName: recruiterUserData.firstName,
  lastName: recruiterUserData.lastName,
  avatar: recruiterUserData.avatar,
  companyName: recruiterUserData.recruiter.name,
  location: recruiterUserData.location,
  yearsExperience: recruiterUserData.yearsExperience,
  email: recruiterUserData.email,
  phone: recruiterUserData.mobileNumber,
  website: recruiterUserData.recruiter.websiteAddress,
  linkedin: recruiterUserData.linkedinUrl,
  verified: recruiterUserData.recruiter.accountVerified,
  new: recruiterUserData.recruiter.isNew,
  score: {
    starRatingPercentage: recruiterUserData.recruiter.feedbackAverage,
  },
});

export default recruiterUserAdapter;
